import moment from 'moment';
const convToTime24 = (date: string) => {
  if (date) {
    return moment(date).format('hh:mm:A');
  }
  return '';
};
export default convToTime24;
